// extracted by mini-css-extract-plugin
export default {"logoIcon":"options_logoIcon__5F9-r","textFieldRename":"options_textFieldRename__IvJ5n"};